if (typeof ZoomInAlt !== 'function') {
    class ZoomInAlt extends HTMLElement {
        constructor() {
            super()

            this.index = 0
            this.init()
        }

        init() {
            this.addEventListener('click', () => {
                this.index = this.dataset.index
                const zoomInOrig = document.querySelector(`[data-product-image-zoom="${this.index}"]`)
                if (zoomInOrig) {
                    zoomInOrig.click()
                }
            })
        }
    }
    
    if ( typeof customElements.get('zoom-in-alt') == 'undefined' ) {
        customElements.define('zoom-in-alt', ZoomInAlt);
    }
}